/**
 * @file
 * Tabs Links script.
 */

(function tabsLinksScript($, Drupal, window, once) {
  'use strict';

  let inboundActiveLinkSet = false;

  function setLinkAsActive(link) {
    const $link = $(link);
    $link
      .closest('.tab-links__item')
      .siblings('.tab-links__item')
      .find('.tab-links__link')
      .removeClass('tab-links__link--active');

    $link.addClass('tab-links__link--active');
  }

  function tabLinkClickKeydownListener(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return;
    }

    setLinkAsActive(event.currentTarget);
  }

  Drupal.behaviors.themeTabsLinks = {
    attach(context) {
      const links = once('themeTabsLinks', '.tab-links__link', context);
      if (!links.length) {
        return;
      }

      // Set inbound anchor as active.
      if (!inboundActiveLinkSet && ('hash' in window.location) && window.location.hash) {
        links.forEach((link) => {
          if (inboundActiveLinkSet) {
            return;
          }

          const href = link.getAttribute('href');
          if (href && href.indexOf('#') === 0 && href === window.location.hash) {
            setLinkAsActive(link);
            inboundActiveLinkSet = true;
          }
        });
      }

      $(links).on('click keydown', tabLinkClickKeydownListener);
    },
  };
}(jQuery, Drupal, window, once));
